import { render, staticRenderFns } from "./IndexOrderItem.vue?vue&type=template&id=31c94c53&scoped=true"
import script from "./IndexOrderItem.vue?vue&type=script&lang=js"
export * from "./IndexOrderItem.vue?vue&type=script&lang=js"
import style0 from "./IndexOrderItem.vue?vue&type=style&index=0&id=31c94c53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c94c53",
  null
  
)

export default component.exports